module.exports = window["core-js/modules/es.string.trim.js"];